import React from 'react'

import PropTypes from 'prop-types'

import styles from './container.module.css'

const Container = (props) => {
  return (
    <div className={` ${styles['container']} ${styles[props.rootClassName]} `}>
      {/* <h1 className={styles['text']}>
        <span></span>
        <span>Ο Κουμπαράς μας</span>
      </h1>
      <img
        alt="image"
        src="/playground_assets/%CF%80%CE%B9%CE%B3-200h.png"
        className={styles['image']}
      />
      <div className={styles['container1']}>
        <h1 className={styles['text03']}>
          <span className={styles['text04']}>
            IBAN
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className={styles['text05']}>:</span>
        </h1>
        <span className={styles['text06']}>GR9802601460000710102239988</span>
      </div>
      <span className={styles['text06']}>(Eurobank)</span> */}
      <span className={styles['text07']}>
        <span className={styles['text08']}>
          Παρακαλώ ενημερώστε μας εάν θα παρευρεθείτε εως τις 
        </span>
        <span>10/07</span>
        <br></br>
        <span></span>
      </span>
      <span className={styles['text09']}>Αριθμοί επικοινωνίας:</span>
      <span className={styles['text10']}>
        Κωνσταντίνος: 6970070668
      </span>
      <span className={styles['text10']}>
        Αδαμαντία: 6980058410
      </span>
    </div>
  )
}

Container.defaultProps = {
  rootClassName: '',
}

Container.propTypes = {
  rootClassName: PropTypes.string,
}

export default Container
